/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import gql from 'graphql-tag';
import { GRAPHQL_ENV } from '../index';

const findAllOccasions = (brand) => (
    gql`{ findAllOccasions(brand: "${brand}", environment: "${GRAPHQL_ENV}") {
            cardCategory
            code
            displayType
            messageText
            name
            rank
            __typename
        }
    }
`
);

export default findAllOccasions;
